import React from 'react';
import PanoramaViewer from './PanoramaViewer';

function App() {
  return (
    <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0 }}>
      <PanoramaViewer />
    </div>
  );
}
export default App;